import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import APICall from "./apiCall.js";
import { getPanelToken } from "./auth/AuthActions.js";

export const DEFAULT_START_DATE = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split("T")[0];
export const DEFAULT_END_DATE = (new Date()).toISOString().split("T")[0];

const sortByDateDesc = (a, b) => {
    if(a.date && b.date){
        return b.date.localeCompare(a.date);
    }else{
        return 0;
    }
};

const eventsEntity = createEntityAdapter({
    selectId: ({ id }) => id,
    sortComparer: sortByDateDesc
});

const eventSelectors = eventsEntity.getSelectors( state => state.events);

export const eventsSlice = createSlice({
    name: "events",
    initialState: eventsEntity.getInitialState(),

    reducers: {
        loadEvents: eventsEntity.addMany,
        clear: eventsEntity.removeAll,
    },
});

// actions

export const loadEvents = (hwaddr, start, end) => {
    const qry = new URLSearchParams();
    if(start){
        qry.set("start", start);
    }
    if(end){
        qry.set("end", end);
    }
    return async dispatch => {
        await dispatch(getPanelToken());
        const data = await APICall(`/v2/sites/${hwaddr}/events?${qry}`, null, {}, "claims")
        dispatch(eventsSlice.actions.loadEvents(data));
    }
}

export const loadRecentEvents = (hwaddr) => loadEvents(hwaddr, DEFAULT_START_DATE, null)

// Selectors

export const selectEvents = (hwaddr, start, end, networkId = null) => state => {
    const events = eventSelectors.selectAll(state);

    return events.filter( e => (
        (e.hwaddr == hwaddr) &&

        (networkId == null || e.networkId == networkId)
    ))
}

export const selectLatestEvent = (hwaddr, networkId = null) => state => {
    const events = eventSelectors.selectAll(state);
    const filteredEvents = events.filter( e => (
        (e.hwaddr == hwaddr) &&
        (networkId == null || e.networkId == networkId)
    ));

    console.log({ filteredEvents });
    return filteredEvents[0]; //filteredEvents.sort( )[0];

}

export const useEventsBasedOnRouter = (start, end) => {
    const { hwaddr, networkId } = useParams();
    const dispatch = useDispatch();

    useEffect(() =>{
        dispatch( loadEvents(hwaddr, start, end))
    }, [hwaddr, start, end])

    return useSelector(
        selectEvents(hwaddr, start, end, networkId)
    );
}

export default eventsSlice.reducer;
